import moment from 'moment';
import { getLanguageList as getLanguageListV2 } from '@pm/super-library-2/utils';
import { getDefaultLoginLanguage } from '@pm/super-library-2/modules/login';

import { userAction, languageAction, gameAction } from 'root/redux/action';
import core from 'root/util/core';
import notification from 'root/util/notification';
import commonUtil from 'root/util/common-util';
import { MODULE_TYPE, SGROUP } from 'root/util/constants';

import { clearSiteKey, resetSitekey } from '@redux/slice/turnstile-slice';
import { USER_LOGIN_ERROR_CODE, CLIENT_EVENT_NAME } from '@redux/constant';

import { walletAction } from '../redux/action/wallet.action';
import { getExternalRegisterTrackingParams } from './external-social-media-util';
import { gu_checkForceChangePasswordPopUp, commonAuthenticatedAction, gu_getMemberKYCData, gu_getNestedValue, gu_filterCommonKey, gu_getLanguageList } from './general-util';
import { mu_checkToShowMissionDiary, mu_loadMenuSettings } from './member-util';

const memberService = {
    // common function to get member message count in project
    getMemberMessageCount(props) {
        return new Promise(function (resolve) {
            if (props.user && props.user.isLogin && !window.isAffiliate) {
                window.SPL_Member.getUnreadMessageCount({
                    memberId: props.user?.account?.memberId,
                }).then(function (count) {
                    let msg = {
                        unreadCount: count.totalUnreadCount,
                        unreadNotificationsCount: count.totalUnreadNotificationCount,
                        unreadInboxCount: count.totalUnreadSystemCount,
                        unreadPromotionCount: count.totalUnreadPromotionCount,
                        unreadPaymentCount: count.totalUnreadPaymentCount,
                        unreadExternalRewardCount: count.totalUnreadExternalRewardCount,
                    };

                    props.dispatch(
                        userAction.getUnreadMsg(
                            count.totalUnreadCount,
                            count.totalUnreadNotificationCount,
                            count.totalUnreadPaymentCount,
                            count.totalUnreadPromotionCount,
                            count.totalUnreadSystemCount,
                            count.totalUnreadExternalRewardCount
                        )
                    );

                    resolve(msg);
                });
            } else {
                resolve(0);
            }
        });
    },

    storePrevPathHistory(prevPathHistory) {
        sessionStorage.setItem('prevPathHistory', prevPathHistory);
    },

    // member login function
    // performance issue, cannot use history.push anymore,
    // must force reload page to ensure data is get correctly
    async memberLogin(vm, options) {
        const navigateAfterLogin = (url) => {
            if (url) {
                window.location.href = url;
            }
        };

        const socialMediaProviderProp = options?.socialMediaProvider;
        const { customNotification, customTranslationObj, socialMediaProvider = socialMediaProviderProp } = vm.state;
        const { history, screen, language, turnstileReducer, authSettingsReducer } = vm.props;
        const { settings } = vm.props.portal;
        const { features, affFeatures, languages } = vm.props.portal.settings;
        const isPendingReviewAcc = features?.loginSettings?.isPendingReviewAcc || false;
        const affAfterLoginRedirectPath = affFeatures?.customAffAfterLoginRedirect || '/overview';
        const customRegionDefaultLangKey = features?.customRegionDefaultLangKey;
        const languageData = await gu_getLanguageList(vm);

        let allowPhoneLogin = false;
        let loginObj = null;
        if (settings) {
            if (settings.features && settings.features.allowPhoneLogin) {
                allowPhoneLogin = gu_filterCommonKey(settings, 'features.allowPhoneLogin', { loop: true });
            }
        }
        vm.setState({ isLoading: true });
        const { fields, displayTelCode } = vm.state;

        const loginModuleType = window.isAffiliate ? MODULE_TYPE.AFF_LOGIN : MODULE_TYPE.LOGIN;

        if (authSettingsReducer?.moduleData?.[loginModuleType]?.turnstileEnabled && turnstileReducer?.turnstileToken?.[loginModuleType]) {
            fields.captchaToken = turnstileReducer?.turnstileToken?.[loginModuleType];
        }

        let loginOri = fields.login;
        const isLoginWithNumber = socialMediaProvider === 'WHATSAPP' || socialMediaProvider === 'PHONE';
        if (isLoginWithNumber) {
            loginOri = `${displayTelCode || ''}${fields.login}`;
        }
        let loginTrim = loginOri.trim();

        if (loginTrim.match(/^\d+$/) && allowPhoneLogin) {
            let currencyLang = null;
            switch (vm.props.language.currencyLang) {
                case 'THB':
                    currencyLang = '66';
                    break;
                case 'SGD':
                    currencyLang = '65';
                    break;
                case 'MYR':
                    currencyLang = '60';
                    break;
                case 'VND':
                    currencyLang = '84';
                    break;
                case 'IDR':
                    currencyLang = '62';
                    break;
                case 'AUD':
                    currencyLang = '61';
                    break;
                case 'HKD':
                    currencyLang = '852';
                    break;
                case 'INR':
                    currencyLang = '91';
                    break;
                case 'PHP':
                    currencyLang = '63';
                    break;
                case 'KHUSD':
                    currencyLang = '855';
                    break;
                case 'PGK':
                    currencyLang = '675';
                    break;
                default:
                    break;
            }
            if (currencyLang === null) {
                currencyLang = '';
            }
            let loginUsername = '';
            loginUsername = loginTrim;
            if (loginTrim.startsWith('0')) {
                loginUsername = loginTrim.substring(1, loginTrim.length);
            }
            loginObj = {
                domain: '',
                isAffiliate: window.isAffiliate ? window.isAffiliate : false,
                isAgent: window.isAgent ? window.isAgent : false,
                isVipLogin: false,
                language: vm.props.language.key,
                merchantCode: window.merchantCode,
                login: currencyLang + loginUsername,
                password: fields.password,
                rememberMe: fields.rememberMe ? fields.rememberMe : false,
                phoneRegister: true,
                isPhoneLogin: true,
                captchaToken: fields.captchaToken,
                currentLoginLanguage: language?.countryLanguageKey,
                defaultLoginLanguage: await getDefaultLoginLanguage(languageData?.languageList, languages, customRegionDefaultLangKey),
            };
        } else {
            loginObj = {
                domain: '',
                isAffiliate: window.isAffiliate ? window.isAffiliate : false,
                isAgent: window.isAgent ? window.isAgent : false,
                isVipLogin: false,
                language: vm.props.language.key,
                merchantCode: window.merchantCode,
                login: loginTrim,
                password: fields.password,
                rememberMe: fields.rememberMe ? fields.rememberMe : false,
                isPhoneLogin: false,
                captchaToken: fields.captchaToken,
                ...(isLoginWithNumber && {
                    isPhoneLogin: true,
                    phoneRegister: true,
                }),
                ...(socialMediaProvider === 'WHATSAPP' && {
                    socialMediaProvider: socialMediaProvider,
                }),
                currentLoginLanguage: language?.countryLanguageKey,
                defaultLoginLanguage: await getDefaultLoginLanguage(languageData?.languageList, languages, customRegionDefaultLangKey),
            };
        }

        if (loginObj.login === '' || loginObj.password === '') {
            notification.showNotification('error', vm.props.t('global:error.empty-authentication'));
            vm.setState({ isLoading: false });

            return;
        }

        core.portalIsLoading(vm.props, true);
        const isAllowTurnstileForLiteApp = settings?.isAllowTurnstileForLiteApp;

        // TODO: will remove isPreventCallApiBeforeReloadPage feature flag in future after everything is stable
        // SUP-119337 - Reduce API called after login & before redirection
        const notAffiliate = !window.isAffiliate;
        const notAgent = !window.isAgent;
        const notKeptOnCurrentPageAfterLogin = !settings?.features?.keptOnCurrentPageAfterLogin;
        const notLiteApp = !window.SPL_LiteApp.isLiteApp();
        const isPreventCallApiBeforeReloadPage = vm.props.flagsmith?.depositCashmarketApi?.isPreventCallApiBeforeReloadPage;
        const isReloadPageAfterLogin = notKeptOnCurrentPageAfterLogin && notAffiliate && notAgent && notLiteApp && isPreventCallApiBeforeReloadPage;
        window.SPL_Member.validateIpDevice(loginTrim).then((data) => {
            if (data.error && data.error !== '') {
                core.portalIsLoading(vm.props, false);
                vm.props.history.push('/redirect-error?' + data.error);
            } else {
                vm.props
                    .dispatch(userAction.login(loginObj, language, isPendingReviewAcc, isAllowTurnstileForLiteApp, isReloadPageAfterLogin))
                    .then(() => {
                        if (isReloadPageAfterLogin) {
                            customFunctionAfterLoginEvent();
                            return;
                        }
                        commonAuthenticatedAction(vm, null, () => {
                            customFunctionAfterLoginEvent(() => {
                                gu_checkForceChangePasswordPopUp(vm);
                                gu_getMemberKYCData(vm);
                            });

                            if (!window.isAgent && !window.isAffiliate) {
                                if (window.SPL_LiteApp.isLiteApp()) {
                                    const { login, password, rememberMe } = loginObj;
                                    const { user } = vm.props;
                                    const currencyData = user && user.account && user.account.currency;

                                    const bioEnabled = window.SPL_LiteApp.isTouchBioAuthUnlocked() || window.SPL_LiteApp.isFaceBioAuthUnlocked();
                                    window.SPL_LiteApp.onLoginSuccess(login, password, rememberMe, bioEnabled ? '1' : '0', currencyData); // 1 yes, 0 no.
                                }
                                vm.props.dispatch(userAction.updateUserVerifications(vm.props));
                            }
                            window.SPL_Cookie.setCookie('EVENT_POSTBACK_PARAMS_ACTION', CLIENT_EVENT_NAME.LOGIN);
                        });
                    })
                    .catch((err) => {
                        core.portalIsLoading(vm.props, false);
                        vm.setState({ isLoading: false });

                        // turnstile handling
                        if (
                            (!window.isAffiliate && vm.props?.authSettingsReducer?.moduleData?.[MODULE_TYPE.LOGIN]?.turnstileEnabled) ||
                            (window.isAffiliate && vm.props?.authSettingsReducer?.moduleData?.[MODULE_TYPE.AFF_LOGIN]?.turnstileEnabled)
                        ) {
                            vm.props?.dispatch(clearSiteKey());
                            vm.props?.dispatch(resetSitekey());
                        }
                        const { history, routeProps } = vm.props;
                        if (err) {
                            // if got dynamic route, use dynamic route's path
                            const regProfileCompletionState = routeProps.settings && routeProps.settings.baseRoute && routeProps.settings.baseRoute.RegisterProfileCompletion;
                            let redirectRegProfileCompletion =
                                regProfileCompletionState && regProfileCompletionState.path ? regProfileCompletionState.path : '/register/profile-completion';
                            if (err.errCode === 1210) {
                                history.push({
                                    pathname: redirectRegProfileCompletion,
                                    state: { isProfileCompletion: true, username: fields.login, password: fields.password },
                                });
                                return;
                            }
                            if (err.errCode === 1201 && window.isAffiliate && !SGROUP.includes(window.merchantCode)) {
                                notification.showNotification('error', vm.props.t('global:error.loginError.accountLockedAff'), {
                                    autoClose: 3000,
                                    onClose: () => window.location.replace('/resetpassword'),
                                });

                                return;
                            }
                        }

                        //  failLoginCode (errorCode) definition
                        // 	1200: Account Suspended
                        // 	1201: Account Locked
                        // 	1202: Account Deleted
                        // 	1203: Wrong Username/Password
                        // 	1204: Account Inactive
                        // 	1205: Pending Approval
                        function handleErrCode() {
                            const { screen, user, t } = vm.props;
                            const { failLoginCode } = user;
                            const customKey = customTranslationObj?.[failLoginCode];
                            const failLoginCodeKey = customKey
                                ? gu_filterCommonKey(customKey)
                                : `global:error.loginError.${failLoginCode === USER_LOGIN_ERROR_CODE.TURNSTILE_ATTEMPT_REACH ? 1203 : failLoginCode}`;
                            const isMobileOrAgent = screen?.isMobile || window.isAgent;
                            const isValidFailLoginCode = window.SPL_Member.isValidFailLoginCode(failLoginCode);
                            const defaultNotificationContent =
                                vm.props.t('global:error.authentication-resetPassword', { interpolation: { escapeValue: false } }) +
                                ' <span style="color: #6a8cb0" onclick="openLiveChatPublic()">' +
                                vm.props.t('global:error.authentication-line-contact') +
                                '</span>';
                            let notificationContent;

                            if (isValidFailLoginCode) {
                                const content = t(failLoginCodeKey, {
                                    interpolation: { escapeValue: isMobileOrAgent },
                                    defaultValue: gu_filterCommonKey(customTranslationObj?.['1205']) || defaultNotificationContent,
                                });
                                notificationContent = !isMobileOrAgent ? <div dangerouslySetInnerHTML={{ __html: content }} /> : content;
                            } else {
                                const content = gu_filterCommonKey(customTranslationObj?.['1205']) || defaultNotificationContent;
                                notificationContent = <div dangerouslySetInnerHTML={{ __html: content }} />;
                            }

                            if (customNotification) {
                                commonUtil.togglePopup(vm, 'notification', notificationContent);
                            } else {
                                notification.showNotification('error', notificationContent);
                            }
                        }

                        const { enableMemberLoginErrorCodeHandling, disableAffiliateLoginErrorCodeHandling } = vm.props.portal?.settings || {};
                        if ((enableMemberLoginErrorCodeHandling && !window.isAffiliate) || (window.isAffiliate && !disableAffiliateLoginErrorCodeHandling)) {
                            handleErrCode();
                            return;
                        }

                        if ((vm.props.screen && vm.props.screen.isMobile) || window.isAgent || window.isAffiliate) {
                            if (vm.props.user.failLoginMessage === 'Pending Approval') {
                                notification.showNotification('error', vm.props.t('global:error.loginError.pendingApproval'));
                            } else if (vm.props.user.failLoginMessage === 'Account Inactive') {
                                notification.showNotification(
                                    'error',
                                    vm.props.t(gu_filterCommonKey(customTranslationObj?.errorAccountInactive) || 'global:error.loginError.accountInactive')
                                );
                            } else if (vm.props.user.failLoginMessage === 'Account Suspended') {
                                notification.showNotification('error', vm.props.t('global:error.loginError.accountSuspended'));
                            } else if (vm.props.user.failLoginMessage === 'Account Deleted') {
                                notification.showNotification('error', vm.props.t('global:error.loginError.accountDeleted'));
                            } else if (vm.props.user.failLoginMessage === 'Account Locked') {
                                notification.showNotification('error', vm.props.t(customTranslationObj?.errorAccountLocked || 'global:error.loginError.accountLocked'));
                            } else if (vm.props.user.failLoginCode === USER_LOGIN_ERROR_CODE.TURNSTILE_ATTEMPT_REACH) {
                                notification.showNotification('error', `global:error.loginError.${USER_LOGIN_ERROR_CODE.TURNSTILE_ATTEMPT_REACH}`);
                                // dispatch turnstile
                            } else {
                                let defaultNotificationContent;
                                let customNotificationContent;
                                if (customTranslationObj && customTranslationObj.errorPendingApproval) {
                                    customNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: customTranslationObj.errorPendingApproval,
                                            }}
                                        />
                                    );
                                } else {
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    vm.props.t('global:error.authentication-resetPassword', { interpolation: { escapeValue: false } }) +
                                                    ' <span style="color: #6a8cb0" onclick="openLiveChatPublic()">' +
                                                    vm.props.t('global:error.authentication-line-contact') +
                                                    '</span>',
                                            }}
                                        />
                                    );
                                }
                                notification.showNotification('error', customNotificationContent ? customNotificationContent : defaultNotificationContent);
                            }
                        } else {
                            let defaultNotificationContent;
                            let customNotificationContent;

                            switch (vm.props.user.failLoginMessage) {
                                case 'Pending Approval':
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: vm.props.t('global:error.loginError.pendingApproval', { interpolation: { escapeValue: false } }),
                                            }}
                                        />
                                    );
                                    break;
                                case 'Account Inactive':
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: vm.props.t(customTranslationObj?.errorAccountInactive || 'global:error.loginError.accountInactive', {
                                                    interpolation: { escapeValue: false },
                                                }),
                                            }}
                                        />
                                    );
                                    break;
                                case 'Account Suspended':
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: vm.props.t('global:error.loginError.accountSuspended', { interpolation: { escapeValue: false } }),
                                            }}
                                        />
                                    );
                                    break;
                                case 'Account Deleted':
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: vm.props.t('global:error.loginError.accountDeleted', { interpolation: { escapeValue: false } }),
                                            }}
                                        />
                                    );
                                    break;
                                case 'Account Locked':
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: vm.props.t(customTranslationObj?.errorAccountLocked || 'global:error.loginError.accountLocked', {
                                                    interpolation: { escapeValue: false },
                                                }),
                                            }}
                                        />
                                    );
                                    break;
                                default:
                                    defaultNotificationContent = (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    vm.props.t('global:error.authentication-resetPassword', { interpolation: { escapeValue: false } }) +
                                                    ' <span style="color: #6a8cb0" onclick="openLiveChatPublic()">' +
                                                    vm.props.t('global:error.authentication-line-contact') +
                                                    '</span>',
                                            }}
                                        />
                                    );

                                    if (customTranslationObj && customTranslationObj.errorPendingApproval) {
                                        customNotificationContent = (
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: customTranslationObj.errorPendingApproval,
                                                }}
                                            />
                                        );
                                    }

                                    break;
                            }

                            if (customNotification) {
                                commonUtil.togglePopup(vm, 'notification', customNotificationContent ? customNotificationContent : defaultNotificationContent);
                            } else {
                                notification.showNotification('error', customNotificationContent ? customNotificationContent : defaultNotificationContent);
                            }
                        }
                    });
            }

            function fetchBasicInfo() {
                return new Promise((resolve) => {
                    window.SPL_Member.getMember(
                        { bioEnabled: false },
                        (account) => {
                            resolve(account);
                        },
                        () => {
                            resolve();
                        }
                    );
                });
            }

            async function customFunctionAfterLoginEvent(callback) {
                // window.SPL_Content.getLanguageList(vm.props).then(async (languageListJson) => {
                let languageListJson = getLanguageListV2(window?.portalSettings);
                const { settings } = vm.props.portal;
                const { language, user } = vm.props;
                let countryLanguage = language.countryLanguageKey;
                const basicInfo = user.account || (await fetchBasicInfo());

                let currentDomainLanguageKey = countryLanguage && countryLanguage.toLowerCase().replace('_', '-'); // dependency on settngs.enableRedirectAfterLogin
                let remainCurrentDomainLangKey = gu_getNestedValue(settings, 'features.remainCurrentDomainLangKey'); // dependency on settngs.enableRedirectAfterLogin

                if (settings && settings.enableRedirectAfterLogin) {
                    let languageModalOrdering = gu_getNestedValue(settings, 'features.languageModalOrdering');
                    if (languageModalOrdering) {
                        let sort = commonUtil.changeLanguageArrangementSort(languageModalOrdering, languageListJson);
                        if (sort) {
                            languageListJson = sort;
                        }
                    }

                    let extraLanguage = gu_getNestedValue(settings, 'features.extraLanguage');
                    if (extraLanguage) {
                        languageListJson.push(extraLanguage);
                    }

                    let globalCurrency = languageListJson.filter(function (a) {
                        let globalCountry = a.languages.filter(function (b) {
                            if (basicInfo?.country) {
                                return b.countryCode.toLowerCase() === basicInfo.country.toLowerCase();
                            } else {
                                return b.currency === (basicInfo?.actualCurrency || basicInfo?.currency);
                            }
                        });

                        return globalCountry.length > 0;
                    });

                    if (globalCurrency.length <= 0) {
                        globalCurrency = languageListJson.filter((a) => a.countryName === 'International');
                    }

                    let customRegionDefaultLangKey = gu_getNestedValue(settings, 'features.customRegionDefaultLangKey');
                    if (customRegionDefaultLangKey) {
                        let region = customRegionDefaultLangKey;

                        countryLanguage =
                            globalCurrency[0] &&
                            globalCurrency[0].languages.filter(function (a) {
                                return a.key === region[a.countryName];
                            });

                        if (!(countryLanguage && countryLanguage.length > 0)) {
                            countryLanguage = globalCurrency[0].languages;
                        }

                        countryLanguage = countryLanguage[0].countryLanguageKey;
                    } else {
                        if (globalCurrency[0]) {
                            countryLanguage = globalCurrency[0].languages[0].countryLanguageKey;
                        }
                    }

                    let countryLanguageKey = countryLanguage;

                    core.setLanguageKeyAndCountryLanguage(vm, countryLanguageKey, languageAction);
                }

                countryLanguage = countryLanguage.toLowerCase();
                countryLanguage = countryLanguage.replace('_', '-');

                if (window.isAffiliate) {
                    core.portalIsLoading(vm.props, false);
                    let checkIsRedirect = new Promise(function (resolve) {
                        core.getCurrentLanguage(false, false, vm, languageAction, basicInfo).then((langPath) => {
                            resolve({
                                isRedirect: true, // diff language
                                currentLang: langPath && langPath.computeLanguage,
                            });
                        });
                    });
                    Promise.all([checkIsRedirect]).then((result) => {
                        let redirectRes = result && result[0];
                        let finalCountryLanguage = remainCurrentDomainLangKey ? currentDomainLanguageKey : redirectRes.currentLang || countryLanguage;
                        vm.setState({ isLoading: false }, () => {
                            // redirect to last url if url param contains redirect
                            let urlParam = window.SPL_Content.parse_query_string();

                            if (urlParam.redirect) {
                                window.location.href = urlParam.redirect;
                            } else {
                                window.location.href = `/${finalCountryLanguage}${affAfterLoginRedirectPath}`;
                            }
                        });
                    });
                } else if (window.isAgent) {
                    core.portalIsLoading(vm.props, false);
                    vm.setState({ isLoading: false }, () => {
                        // redirect to last url if url param contains redirect
                        let urlParam = window.SPL_Content.parse_query_string();
                        if (urlParam.redirect) {
                            window.location.href = '/myaccount/deposit';
                        } else {
                            window.location.href = '/';
                        }
                    });
                } else {
                    core.portalIsLoading(vm.props, false);

                    vm.setState({ isLoading: false }, () => {
                        if (history.location.search.includes('App')) {
                            if (isReloadPageAfterLogin) {
                                window.location.href = '/download' + history.location.search;
                            } else {
                                history.push('/download' + history.location.search);
                                callback && callback();
                            }
                        } else {
                            // redirect to last url if url param contains redirect
                            let urlParam = window.SPL_Content.parse_query_string();
                            if (urlParam.redirect) {
                                if (isReloadPageAfterLogin) {
                                    window.location.href = urlParam.redirect;
                                } else {
                                    history.push(urlParam.redirect);
                                    callback && callback();
                                }
                            } else {
                                //check user login language key and previous language key to decide isRedirect
                                let checkIsRedirect = new Promise(function (resolve) {
                                    core.getCurrentLanguage(false, false, vm, languageAction, basicInfo).then((langPath) => {
                                        resolve({
                                            isRedirect: true, // diff language
                                            currentLang: langPath && langPath.computeLanguage,
                                        });
                                    });
                                });
                                Promise.all([checkIsRedirect]).then((result) => {
                                    let redirectRes = result && result[0];
                                    let finalCountryLanguage = remainCurrentDomainLangKey ? currentDomainLanguageKey : redirectRes.currentLang || countryLanguage;
                                    const redirectUrl = gu_filterCommonKey(features.customLoginRedirectPage);

                                    if (!screen.isMobile) {
                                        if (settings && settings.enableRedirectAfterLogin && !(redirectRes && redirectRes.isRedirect)) {
                                            //when enableRedirectAfterLogin is true using isRedirect to decide whether redirect or not in here
                                            callback && callback();
                                            return;
                                        } else if (redirectUrl) {
                                            if (redirectUrl === 'myaccount/mission-diary') {
                                                mu_checkToShowMissionDiary(vm).then((res) => {
                                                    window.location.href = res ? redirectUrl : '/myaccount/deposit';
                                                });
                                            } else {
                                                window.location.href = '/' + finalCountryLanguage + redirectUrl;
                                            }
                                        } else {
                                            let pathname = window.location.pathname;
                                            const { menuSlice } = vm.props || {};
                                            const isMenuV3 = window.isMenuV3 && menuSlice.menuList;
                                            const baseMenuSettings = isMenuV3 ? menuSlice.processedBaseMenuSettings.subCategoryMenus : menuSlice.baseMenuSettings;
                                            const spsUrl = (isMenuV3 ? baseMenuSettings?.S : baseMenuSettings?.web?.subCategory?.S?.submenu)?.find(
                                                (item) => item.name === 'SPS'
                                            );
                                            const isSpsPage = spsUrl && pathname.includes(spsUrl.route);

                                            if (isSpsPage && settings?.features?.providerPageSettings?.superSports?.stayAfterLogin) {
                                                window.location.reload();
                                            } else if (
                                                settings &&
                                                settings.features &&
                                                settings.features.hideLangPathUrl &&
                                                settings.features.hideLangPathUrl[countryLanguage]
                                            ) {
                                                window.location.href = '/myaccount/deposit';
                                            } else if (!settings?.features?.keptOnCurrentPageAfterLogin) {
                                                window.location.href = '/' + finalCountryLanguage + '/myaccount/deposit';
                                            } else if (gu_filterCommonKey(settings, 'features.forceToLoginPageWhilePlyGame')) {
                                                const storedPrevPathHistory = sessionStorage.getItem('prevPathHistory');
                                                sessionStorage.removeItem('prevPathHistory');
                                                window.location.href = storedPrevPathHistory;
                                            }
                                        }
                                    } else {
                                        if (settings && settings.landingPageDomains && settings.landingPageDomains.indexOf(window.location.hostname) >= 0) {
                                            window.location.href = '/' + countryLanguage;
                                        } else if (redirectUrl) {
                                            if (redirectUrl === 'myaccount/mission-diary') {
                                                mu_checkToShowMissionDiary(vm).then((res) => {
                                                    window.location.href = res ? redirectUrl : '/';
                                                });
                                            } else {
                                                window.location.href = '/' + finalCountryLanguage + redirectUrl;
                                            }
                                        } else {
                                            /**
                                             * TODO: investigate issue cannot load on iOS mobile
                                             * Temporary fix by mobileForceRedirectHome
                                             */
                                            if (finalCountryLanguage) {
                                                let nextUrl = '/' + finalCountryLanguage;
                                                if (window.mobileForceRedirectHome && screen?.isMobile) {
                                                    nextUrl += '/home';
                                                }
                                                navigateAfterLogin(nextUrl);
                                            } else {
                                                let nextUrl = '/';
                                                if (window.mobileForceRedirectHome && screen?.isMobile) {
                                                    nextUrl += 'home';
                                                }
                                                navigateAfterLogin(nextUrl);
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
                // });
            }
        });
    },

    filterAccountMenu(vm) {
        const { screen } = vm.props;
        if (screen && screen.isMobile) {
            commonUtil.checkResigterWithContactSupport(vm, 'mobile');
        } else {
            commonUtil.checkResigterWithContactSupport(vm, 'desktop').then(() => {
                if (vm.state.regWithContactSupport && vm.state.regWithContactSupport.isEnabled) {
                    const { accountMenu, settingsTab } = vm.state;
                    accountMenu.splice(1, 2);
                    settingsTab.splice(1, 2);

                    vm.props.history.push('/myaccount/myprofile');
                    vm.setState({ accountMenu, settingsTab });
                }
            });
        }
    },

    loadProviders(vm, loadAsync, isPreventCallApiProviderWallets = false) {
        // for funds landing page usage
        vm.setState({ iconLoading: true });
        const { features } = vm.props.portal.settings;
        let transferSettings = {};
        if (features && features.transferSettings) {
            transferSettings = features.transferSettings;
        }

        window.SPL_Provider.getAllProviderWalletList(null, false, vm.props)
            .then((data) => {
                let tempProviderList = data.providerList;
                let providerList = [];
                let leftProviderList = [];
                let rightProviderList = [];
                let fromProvider;
                let foundMainWalletIndex = 0;

                // let mainWallet = tempProviderList.filter(a => a.provider === null)[0];
                tempProviderList = tempProviderList.filter((a) => a.provider !== null);
                tempProviderList = tempProviderList.slice(0).sort(function (a, b) {
                    return a['provider'] > b['provider'] ? 1 : a['provider'] < b['provider'] ? -1 : 0;
                });

                // providerList.push(mainWallet);
                for (let i = 0; i < tempProviderList.length; i++) {
                    providerList.push(tempProviderList[i]);
                }

                for (let i = 0; i < data.providerList.length; i++) {
                    // default select main wallet
                    if (data.providerList[i].provider === null) {
                        foundMainWalletIndex = i;
                        fromProvider = data.providerList[i];
                        break;
                    }
                }

                let transferValue = null;

                if (fromProvider) {
                    transferValue = window.SPL_Other.formatAmount(fromProvider.balance) || window.SPL_Other.formatAmount('0');
                } else {
                    transferValue = window.SPL_Other.formatAmount('0');
                }
                transferValue = transferValue.replace(/,/g, '');

                providerList = providerList.slice(0).sort(function (a, b) {
                    return a['provider'] > b['provider'] ? 1 : a['provider'] < b['provider'] ? -1 : 0;
                });

                if (features && features.splitProviderToLeftAndRight) {
                    let tempProviderList2 = tempProviderList;
                    let halfProvider = Math.ceil(tempProviderList2.length / 2);
                    leftProviderList = tempProviderList2.splice(0, halfProvider);
                    // after splice, remain half hence just direct add can le
                    rightProviderList = tempProviderList2;
                }

                vm.props.dispatch(walletAction.updateProviderWallets(providerList));
                vm.setState({
                    providerList: providerList,
                    iconLoading: false,
                    transferAmount: transferValue,
                    fromProvider: transferSettings.showPleaseSelect && transferSettings.showPleaseSelect.from ? '' : fromProvider, // purposely set to item count because could not bind object to value
                    toProvider: transferSettings.showPleaseSelect && transferSettings.showPleaseSelect.to ? '' : foundMainWalletIndex, // purposely set to item count because could not bind object to value
                    disabledDepositButton: transferSettings.showPleaseSelect ? true : false,
                    maximumAmount: transferValue,
                    leftProviderList: leftProviderList,
                    rightProviderList: rightProviderList,
                });
            })
            .then(() => {
                if (loadAsync) {
                    memberService.loadAsyncProviderWallet(vm, true, isPreventCallApiProviderWallets);
                }
            });
    },

    loadAsyncProviderWallet(vm, check, isPreventCallApiProviderWallets = false) {
        const { user } = vm.props;
        window.SPL_Provider.loadAsyncProviderWallet(check, vm.props, false, user?.account?.id, isPreventCallApiProviderWallets).then((providerWallet) => {
            memberService.updateProviderList(vm, providerWallet.providerList);

            // provider wallet use v2 so can't use this anymore
            // if (providerWallet.requireToReCallApi) {
            //     setTimeout(() => {
            //         memberService.loadAsyncProviderWallet(vm, false);
            //     }, 1000);
            // } else {
            //     memberService.updateProviderList(vm, providerWallet.providerList);
            // }
        });
    },

    updateProviderList(vm, providerWallet) {
        const { providerList } = vm.state;
        if (providerList && providerList.length > 0) {
            for (let i = 0; i < providerList.length; i++) {
                let results = providerWallet.filter(function (e) {
                    return e.provider === providerList[i].provider;
                })[0];

                if (results) {
                    providerList[i].balance = results.balance ? results.balance : 0;
                    providerList[i].serverIsUnderMaintenance = results.serverIsUnderMaintenance;
                    providerList[i].isdisplay = true;
                    providerList[i].serverMaintenanceStr = results.serverIsUnderMaintenance ? 'error:error.underMaintainance' : '';
                } else {
                    providerList[i].serverMaintenanceStr = '';
                }

                vm.setState({ providerList: providerList });
            }
        }
    },

    /* funds page transfer wallet popup start */
    loadPromotions(vm, provider) {
        let promotionList = [];
        if (provider) {
            const { user, language, portal, screen } = vm.props;
            const { promoList, selectedPromotion } = vm.state;
            const prevSelectedPromoId = promoList && promoList[selectedPromotion] ? promoList[selectedPromotion].id : 0;

            let platform = null;
            if (portal && portal.settings && portal.settings.getPromoCodeByPlatform) {
                if (window.SPL_LiteApp.isLiteApp()) {
                    platform = 'A';
                } else if (screen.viewType === 'web') {
                    platform = 'W';
                } else {
                    platform = 'M';
                }
            }

            window.SPL_Provider.loadPromotions(provider, user.account.login, language.countryLanguageKey, platform).then((newPromoList) => {
                //promotionList = promoList;
                if (newPromoList && newPromoList.length > 0) {
                    promotionList.push({
                        id: 0,
                        provider: null,
                        bonusName: vm.props.t('global:global.form.pleaseSelect'),
                    });
                    for (let i = 0; i < newPromoList.length; i++) {
                        promotionList.push(newPromoList[i]);
                    }
                } else {
                    promotionList.push({
                        id: 0,
                        provider: null,
                        bonusName: vm.props.t('reports:reports.noDataAvailable', 'No Data Available'),
                    });
                }
                const selectedPromoNewIndex = promotionList.findIndex((item) => {
                    return item.id === prevSelectedPromoId;
                });
                vm.setState({
                    promoList: promotionList,
                    selectedPromotion: selectedPromoNewIndex !== -1 ? selectedPromoNewIndex : 0,
                    specialPromoCode: '',
                    specialPromo: null,
                    isValidSpecialPromoCode: false,
                    specialPromoAmountPlaceHolder: '',
                    promoListVisible: true,
                });
            });
        } else {
            if (promotionList.length === 0) {
                promotionList.push({
                    id: 0,
                    provider: null,
                    bonusName: vm.props.t('reports:reports.noDataAvailable', 'No Data Available'),
                });
            }

            vm.setState({
                promoList: promotionList,
                selectedPromotion: '',
                specialPromoCode: '',
                specialPromo: null,
                isValidSpecialPromoCode: false,
                specialPromoAmountPlaceHolder: '',
                promoListVisible: false,
            });
        }
    },

    loadPromoProvider(vm, promoId) {
        window.SPL_Provider.loadPromotionProvider(promoId).then((providers) => {
            return providers;
        });
    },

    handleAmountChange(vm, e, checkSpecialPromotion = false) {
        const { transferAmount, compSettings } = vm.state;
        let fromProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.fromProvider);
        let toProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.toProvider);
        if (fromProvider && fromProvider.provider) {
            fromProvider = fromProvider.provider;
        }
        if (toProvider && toProvider.provider) {
            toProvider = toProvider.provider;
        }

        let value = '';
        if (!e.target) {
            value = e;
        } else {
            value = e.target.value;
        }

        if (value) {
            window.SPL_Transaction.checkDecimalByProvider(toProvider, fromProvider, value).then((data) => {
                if (data && data.removeDecimal) {
                    if (value.toString().match(/^(\d*){0,1}$/)) {
                        vm.setState(
                            {
                                transferAmount: value,
                                errors: {},
                            },
                            () => {
                                if (checkSpecialPromotion) {
                                    memberService.verifySpecialPromotion(vm);
                                }
                            }
                        );
                    } else {
                        vm.setState({
                            errors: {},
                        });
                    }
                } else {
                    // Can be zero or more digits before the decimal point.
                    // Can be zero or one decimal point.
                    // Can be up to two digits after the decimal point.
                    if (value.toString().match(/^(\d*)\.{0,1}(\d){0,2}$/)) {
                        const decimalRegex = /^\d*\.\d*$/;
                        const disabledDepositButton =
                            ((compSettings?.noDecimalAllowedProviders || []).includes(toProvider) || (compSettings?.noDecimalAllowedProviders || []).includes(fromProvider)) &&
                            decimalRegex.test(value);
                        const errors = disabledDepositButton
                            ? {
                                  amount: 'transaction:transaction.withdrawal.disableDecimalError',
                              }
                            : {};

                        vm.setState(
                            {
                                transferAmount: value,
                                errors: errors,
                                disabledDepositButton: disabledDepositButton,
                            },
                            () => {
                                if (checkSpecialPromotion) {
                                    memberService.verifySpecialPromotion(vm);
                                }
                            }
                        );
                    } else {
                        vm.setState({
                            errors: {
                                amount: 'transaction:transaction.invalidAmount',
                            },
                        });
                    }
                }
            });
        } else {
            vm.setState({ transferAmount: value }, () => {
                if (checkSpecialPromotion) {
                    if (!transferAmount) {
                        vm.setState({ transferAmount: window.SPL_Other.formatAmount('0') });
                    }
                    memberService.verifySpecialPromotion(vm);
                }
            });
        }

        memberService.validateTransferSubmitBtn(vm, value);
    },

    handleAmountFocus(vm) {
        const { transferAmount } = vm.state;
        if (transferAmount === '0.00') {
            vm.setState({ transferAmount: '' });
        }
    },

    validateTransferSubmitBtn(vm, amount) {
        let fromProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.fromProvider);
        let toProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.toProvider);

        const selectedPromotionIndex = gu_getNestedValue(vm, `state.selectedPromotion`);
        const selectedPromo = gu_getNestedValue(vm, `state.promoList.${[selectedPromotionIndex]}`);
        const exceedMaxBonus = gu_getNestedValue(selectedPromo, `exceedMaxBonus`);
        const bonusGroup = gu_getNestedValue(selectedPromo, `bonusGroup`);
        const isFreeBetValid = bonusGroup === 'FREE_BET' && amount >= 0;

        if (fromProvider && toProvider) {
            if (
                !isFreeBetValid &&
                (selectedPromotionIndex || selectedPromotionIndex === 0) &&
                !vm.state.disablePromotionMinMaxChecking &&
                (amount < vm.state.minPromoAmount || (amount > vm.state.maxPromoAmount && !exceedMaxBonus)) &&
                vm.state.minPromoAmount !== 0 &&
                vm.state.maxPromoAmount !== 0
            ) {
                vm.setState({ disabledDepositButton: true });
            } else if (fromProvider && amount > fromProvider.balance) {
                vm.setState({
                    disabledDepositButton: true,
                    errors: {
                        ...vm.state.errors,
                        amount: 'transaction:transaction.transfer.invalidAmount',
                    },
                });
            } else if ((amount && amount >= vm.state.minimumAmount) || isFreeBetValid) {
                vm.setState({ disabledDepositButton: false });
            } else {
                vm.setState({ disabledDepositButton: true });
            }
        }
    },

    verifySpecialPromotion(vm) {
        const { language } = vm.props;
        if (vm.state.allowSpecialCode && vm.state.specialPromoCode !== null && vm.state.specialPromoCode !== '') {
            let fromProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.fromProvider);
            let toProvider = memberService.getCorrespondingProviderObjectByIndex(vm, vm.state.toProvider);
            let login = vm.props.user.account.login;
            let specialPromoCode = vm.state.specialPromoCode;
            let transferAmount = vm.state.transferAmount;

            window.SPL_Transaction.verifyPromotionCode(
                null,
                login,
                specialPromoCode,
                fromProvider.provider,
                toProvider.provider,
                transferAmount,
                language && language.countryLanguageKey
            ).then((result) => {
                let transferAmount = vm.state.transferAmount;
                if (result.isValidPromo && !result.specialPromo.exceedMaxBonus) {
                    transferAmount = result.isValidSpecialPromoAmount ? transferAmount : '';
                }

                vm.setState(
                    {
                        isValidSpecialPromoCode: result.isValidPromo && result.isValidSpecialPromoProvider,
                        transferAmount: transferAmount,
                        specialPromoAmountPlaceHolder: result.amountPlaceHolder,
                        minimumAmount: result.minimumAmount,
                    },
                    () => {
                        if (vm.state.isValidSpecialPromoCode) {
                            vm.setState({ specialPromo: result.specialPromo });
                        }
                        memberService.validateTransferSubmitBtn(vm, vm.state.transferAmount);
                    }
                );
            });
        } else {
            vm.setState({ specialPromoAmountPlaceHolder: '' });
        }
    },

    getCorrespondingProviderObjectByIndex(vm, index) {
        if (typeof index === 'object') {
            return index;
        } else {
            return vm.state.providerList[index];
        }
    },
    /* transfer wallet popup end */

    getProgressBarData(vm) {
        commonUtil.getProgressBarData(vm);
    },

    getExternalLoginRegister(vm, action, provider) {
        const { screen } = vm.props;
        let isLiteApp = false;

        if (provider === 'WHATSAPP') {
            vm.props.history.push('/register/external-quick-register?socialMediaProvider=WHATSAPP');
            window.location.reload();
            return;
        }

        if (window.SPL_LiteApp.isLiteApp()) {
            const pathName = vm.props.portal.pathname;
            if (pathName.indexOf('liteapp') !== -1) {
                isLiteApp = true;
            }
        }
        let params = null;
        if (action === 'register') {
            params = {
                lang: vm.props.language.key,
                affCode: window.SPL_Cookie.getCookie('AffCode'),
                ...getExternalRegisterTrackingParams(action),
                isMobile: false,
                provider: provider,
                memberId: null,
                portalRedirect: null,
                action: 'register',
                liteApp: isLiteApp,
            };
        } else {
            params = {
                lang: vm.props.language.key,
                affCode: window.SPL_Cookie.getCookie('AffCode'),
                ...getExternalRegisterTrackingParams(action),
                isMobile: false,
                provider: provider,
                memberId: null,
                portalRedirect: null,
                action: 'login',
                liteApp: isLiteApp,
            };
        }

        window.SPL_Register.getExternalRegisterSettings(params).then(onSuccess, onError);

        function onSuccess(response) {
            if (screen.isMobile) {
                window.SPL_LiteApp.onLineLoginTapped(response[provider]);
                window.location.replace(response[provider]);
            } else {
                window.location.replace(response[provider]);
            }
        }

        function onError(err) {
            console.log(err);
        }
    },

    getJustForYouGame(vm, props, gameType, cb) {
        let loadGetJustForYouGameList = new Promise((resolve) => {
            window.SPL_Content.getJustForYouGameList().then((res) => resolve(res));
        });

        // let loadProviderGameMaintenanceList = new Promise((resolve) => {
        //     window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        // });

        Promise.all([loadGetJustForYouGameList]).then((loadResult) => {
            let gameList = loadResult[0];
            let providerMaintenance = vm.state.providerMaintenanceList;

            gameList = gu_filterCommonKey(gameList, gameType) || gameList;
            if (gameList && gameList.length > 0) {
                for (let i = 0; i < gameList.length; i++) {
                    if (providerMaintenance) {
                        for (let j = 0; j < providerMaintenance.length; j++) {
                            let maintenanceProvider = providerMaintenance[j].provider;

                            if (gameList[i].provider === maintenanceProvider) {
                                gameList[i].underMaintenance = providerMaintenance[j];
                                gameList[i].providerMaintenanceName = gameList[i].name;
                            }
                        }
                    }
                }

                vm.setState({ hotGameList: gameList, showRTPValue: gameList.showRTPValue }, () => {
                    if (cb) {
                        cb();
                    }
                    memberService.getMemberFavoriteGame(vm, props);
                });
            }
        });
    },

    getMemberFavoriteGame(vm, props) {
        const { screen } = props;
        let isMobile = null,
            hotGame = vm.state.hotGameList;

        if (screen.viewType === 'web') {
            isMobile = false;
        } else {
            isMobile = true;
        }

        for (let i = 0; i < hotGame.length; i++) {
            hotGame[i].isFav = false;
        }

        let loadGetMemberFavoriteGame = new Promise((resolve) => {
            window.SPL_Member.getMemberFavoriteGame(isMobile).then((res) => resolve(res));
        });

        // let loadProviderGameMaintenanceList = new Promise((resolve) => {
        //     window.SPL_Provider.providerGameMaintenanceList(null, null, language.currencyLang).then((result) => resolve(result));
        // });

        Promise.all([loadGetMemberFavoriteGame]).then((loadResult) => {
            let favoriteGame = loadResult[0];
            let providerMaintenance = vm.state.providerMaintenanceList;

            let favGameList = favoriteGame.favoritedGame;

            for (let k = 0; k < favGameList.length; k++) {
                favGameList[k].imggame = `/public/html/games/images/s1/${favGameList[k].provider}/${favGameList[k].game}.jpg`;

                if (providerMaintenance) {
                    for (let j = 0; j < providerMaintenance.length; j++) {
                        let maintenanceProvider = providerMaintenance[j].provider;

                        if (favGameList[k].provider === maintenanceProvider) {
                            favGameList[k].underMaintenance = providerMaintenance[j];
                        }
                    }
                }

                for (let a = 0; a < hotGame.length; a++) {
                    if (favGameList[k].game === hotGame[a].gameCode) {
                        hotGame[a].isFav = true;
                    }
                }
            }
            vm.setState({ favoritedGame: favGameList, hotGameList: hotGame, isLoading: false });
        });
    },

    updateMemberFavoriteGame(vm, props, game) {
        vm.setState({ isLoading: true }, () => {
            const { screen } = props;
            const { isLogin } = props.user;
            const { favoritedGame } = vm.state;
            let isMobile = null;
            let gameCode = game.game ? game.game : game.gameCode;

            if (screen.viewType === 'web') {
                isMobile = false;
            } else {
                isMobile = true;
            }

            if (isLogin) {
                let delelteGame = false;

                for (let i = 0; i < favoritedGame.length; i++) {
                    if (favoritedGame[i].game === gameCode) {
                        delelteGame = true;
                    }
                }

                if (delelteGame === true) {
                    window.SPL_Member.deleteMemberFavoriteGame(game.provider, game.category, gameCode, isMobile).then(() => {
                        memberService.getMemberFavoriteGame(vm, props);
                    });
                } else {
                    window.SPL_Member.updateMemberFavoriteGame(game.provider, game.category, gameCode, isMobile).then(() => {
                        memberService.getMemberFavoriteGame(vm, props);
                    });
                }
            } else {
                // if (isMobile) {
                //     controller.vm.props.dispatch(portalAction.floatingPageUpdated('login'));
                // } else {
                //     notification.showNotification('error', props.t('home:home.loginText'));
                // }
                vm.setState({ isLoading: false });
            }
        });
    },

    classifyMemberGroupCategory(memberGroup, memberGroupList, callingAPI) {
        let memberGroupCategory = ['NORMAL', 'BRONZE', 'SILVER', 'GOLD', 'PLATINUM', 'DIAMOND'];

        if (memberGroupList || callingAPI) memberGroupCategory = memberGroupList || [];

        for (var i = 0; i < memberGroupCategory.length; i++) {
            let group = memberGroupCategory[i].key || memberGroupCategory[i];

            if (memberService.similarity(group, memberGroup) > 0.9) {
                return group;
            }
        }

        return memberGroup;
    },

    /**
     * 	JaroWinklerDistance
     * 	Copied from https://medium.com/@sumn2u/string-similarity-comparision-in-js-with-examples-4bae35f13968
     *
     */
    similarity(s1, s2) {
        var m = 0;

        // Exit early if either are empty.
        if (s1.length === 0 || s2.length === 0) {
            return 0;
        }

        s1 = s1.toUpperCase();
        s2 = s2.toUpperCase();
        // Exit early if they're an exact match.
        if (s1 === s2) {
            return 1;
        }

        var range = Math.floor(Math.max(s1.length, s2.length) / 2) - 1;
        var s1Matches = new Array(s1.length);
        var s2Matches = new Array(s2.length);

        for (var i = 0; i < s1.length; i++) {
            var low = i >= range ? i - range : 0;
            var high = i + range <= s2.length - 1 ? i + range : s2.length - 1;

            for (var j = low; j <= high; j++) {
                if (s1Matches[i] !== true && s2Matches[j] !== true && s1[i] === s2[j]) {
                    ++m;
                    s1Matches[i] = s2Matches[j] = true;
                    break;
                }
            }
        }

        // Exit early if no matches were found.
        if (m === 0) {
            return 0;
        }
        // Count the transpositions.
        var k = 0;
        var numTrans = 0;

        for (var a = 0; a < s1.length; a++) {
            if (s1Matches[a] === true) {
                for (var b = k; b < s2.length; b++) {
                    if (s2Matches[b] === true) {
                        k = b + 1;
                        break;
                    }
                }

                if (s1[a] !== s2[b]) {
                    ++numTrans;
                }
            }
        }

        var weight = (m / s1.length + m / s2.length + (m - numTrans / 2) / m) / 3;
        var l = 0;
        var p = 0.1;

        if (weight > 0.7) {
            while (s1[l] === s2[l] && l < 4) {
                ++l;
            }

            weight = weight + l * p * (1 - weight);
        }

        return weight;
    },

    getMemberTurnoverDataBase(callback) {
        window.SPL_Member.getMemberTurnoverData().then((data) => {
            if (data) {
                const memberTurnoverData = {
                    eligibleWithdraw: data.eligibleWithdraw && data.eligibleWithdraw > 0 ? data.eligibleWithdraw : 0,
                    amount: data.amount && data.amount > 0 ? data.amount : 0,
                    currency: data.currency ? data.currency : '',
                    remainingTurnover: data.remainingTurnover && data.remainingTurnover > 0 ? data.remainingTurnover : 0,
                    now: moment().format('DD-MM-YYYY hh:mm:ss').toString(),
                };

                callback?.(memberTurnoverData);
            }
        });
    },

    getMemberTurnoverData(vm) {
        if (vm.state.compSettings && vm.state.compSettings.showMemberTurnover) {
            memberService.getMemberTurnoverDataBase((memberTurnoverData) => {
                vm.setState({ memberTurnoverData: memberTurnoverData });
            });
        }
    },

    // member external login function
    // performance issue, cannot use history.push anymore,
    // must force reload page to ensure data is get correctly
    // removed as not really needed
    // memberExternalLogin(vm) {
    //     const { customNotification, customTranslationObj, socialMediaProvider } = vm.state;
    //     const { history, screen, language } = vm.props;
    //     const { features } = vm.props.portal.settings;
    //     let loginObj = null;
    //     vm.setState({ isLoading: true });
    //     const { fields, displayTelCode } = vm.state;

    //     // whatsappNumber
    //     let loginOri = `${displayTelCode}${fields.login}`;
    //     let loginTrim = loginOri.trim();
    //     if (loginTrim.startsWith('0')) {
    //         loginTrim.substring(1, loginTrim.length);
    //     }

    //     loginObj = {
    //         domain: '',
    //         isAffiliate: window.isAffiliate ? window.isAffiliate : false,
    //         isAgent: window.isAgent ? window.isAgent : false,
    //         isVipLogin: false,
    //         language: vm.props.language.key,
    //         merchantCode: window.merchantCode,
    //         login: loginTrim,
    //         password: fields.password,
    //         rememberMe: fields.rememberMe ? fields.rememberMe : false,
    //         phoneRegister: true,
    //         socialMediaProvider: socialMediaProvider,
    //         isPhoneLogin: true,
    //     };

    //     if (loginObj.login === '' || loginObj.password === '') {
    //         notification.showNotification('error', vm.props.t('global:error.empty-authentication'));
    //         return;
    //     }

    //     core.portalIsLoading(vm.props, true);

    //     window.SPL_Member.validateIpDevice(loginTrim).then((data) => {
    //         if (data.error && data.error !== '') {
    //             core.portalIsLoading(vm.props, false);
    //             vm.props.history.push('/redirect-error?' + data.error);
    //         } else {
    //             vm.props
    //                 .dispatch(userAction.login(loginObj, language))
    //                 .then(() => {
    //                     commonAuthenticatedAction(vm, null, () => {
    //                         customFunctionAfterLoginEvent(() => {
    //                             gu_checkForceChangePasswordPopUp(vm);
    //                             gu_getMemberKYCData(vm);
    //                         });

    //                         if (!window.isAgent && !window.isAffiliate) {
    //                             if (window.SPL_LiteApp.isLiteApp()) {
    //                                 const { login, password, rememberMe } = loginObj;
    //                                 const { user } = vm.props;
    //                                 const currencyData = user && user.account && user.account.currency;

    //                                 const bioEnabled = window.SPL_LiteApp.isTouchBioAuthUnlocked() || window.SPL_LiteApp.isFaceBioAuthUnlocked();
    //                                 window.SPL_LiteApp.onLoginSuccess(login, password, rememberMe, bioEnabled ? '1' : '0', currencyData); // 1 yes, 0 no.
    //                             }
    //                             vm.props.dispatch(userAction.updateUserVerifications(vm.props));
    //                         }
    //                     });
    //                 })
    //                 .catch((err) => {
    //                     core.portalIsLoading(vm.props, false);
    //                     vm.setState({ isLoading: false });

    //                     const { history, routeProps } = vm.props;
    //                     if (err) {
    //                         // if got dynamic route, use dynamic route's path
    //                         const regProfileCompletionState = routeProps.settings && routeProps.settings.baseRoute && routeProps.settings.baseRoute.RegisterProfileCompletion;
    //                         let redirectRegProfileCompletion =
    //                             regProfileCompletionState && regProfileCompletionState.path ? regProfileCompletionState.path : '/register/profile-completion';
    //                         if (err.errCode === 1210) {
    //                             history.push({
    //                                 pathname: redirectRegProfileCompletion,
    //                                 state: { isProfileCompletion: true, username: fields.login, password: fields.password },
    //                             });
    //                             return;
    //                         }
    //                     }

    //                     if ((vm.props.screen && vm.props.screen.isMobile) || window.isAgent) {
    //                         if (vm.props.user.failLoginMessage === 'Pending Approval') {
    //                             notification.showNotification('error', vm.props.t('global:error.loginError.pendingApproval'));
    //                         } else if (vm.props.user.failLoginMessage === 'Account Inactive') {
    //                             notification.showNotification(
    //                                 'error',
    //                                 vm.props.t(gu_filterCommonKey(customTranslationObj?.errorAccountInactive) || 'global:error.loginError.accountInactive')
    //                             );
    //                         } else if (vm.props.user.failLoginMessage === 'Account Suspended') {
    //                             notification.showNotification('error', vm.props.t('global:error.loginError.accountSuspended'));
    //                         } else if (vm.props.user.failLoginMessage === 'Account Deleted') {
    //                             notification.showNotification('error', vm.props.t('global:error.loginError.accountDeleted'));
    //                         } else if (vm.props.user.failLoginMessage === 'Account Locked') {
    //                             notification.showNotification('error', vm.props.t(customTranslationObj?.errorAccountLocked || 'global:error.loginError.accountLocked'));
    //                         } else {
    //                             let defaultNotificationContent;
    //                             let customNotificationContent;
    //                             if (customTranslationObj && customTranslationObj.errorPendingApproval) {
    //                                 customNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: customTranslationObj.errorPendingApproval,
    //                                         }}
    //                                     />
    //                                 );
    //                             } else {
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html:
    //                                                 vm.props.t('global:error.authentication-resetPassword', { interpolation: { escapeValue: false } }) +
    //                                                 ' <span style="color: #6a8cb0" onclick="openLiveChatPublic()">' +
    //                                                 vm.props.t('global:error.authentication-line-contact') +
    //                                                 '</span>',
    //                                         }}
    //                                     />
    //                                 );
    //                             }
    //                             notification.showNotification('error', customNotificationContent ? customNotificationContent : defaultNotificationContent);
    //                         }
    //                     } else {
    //                         let defaultNotificationContent;
    //                         let customNotificationContent;

    //                         switch (vm.props.user.failLoginMessage) {
    //                             case 'Pending Approval':
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: vm.props.t('global:error.loginError.pendingApproval', { interpolation: { escapeValue: false } }),
    //                                         }}
    //                                     />
    //                                 );
    //                                 break;
    //                             case 'Account Inactive':
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: vm.props.t(customTranslationObj?.errorAccountInactive || 'global:error.loginError.accountInactive', {
    //                                                 interpolation: { escapeValue: false },
    //                                             }),
    //                                         }}
    //                                     />
    //                                 );
    //                                 break;
    //                             case 'Account Suspended':
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: vm.props.t('global:error.loginError.accountSuspended', { interpolation: { escapeValue: false } }),
    //                                         }}
    //                                     />
    //                                 );
    //                                 break;
    //                             case 'Account Deleted':
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: vm.props.t('global:error.loginError.accountDeleted', { interpolation: { escapeValue: false } }),
    //                                         }}
    //                                     />
    //                                 );
    //                                 break;
    //                             case 'Account Locked':
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html: vm.props.t(customTranslationObj?.errorAccountLocked || 'global:error.loginError.accountLocked', {
    //                                                 interpolation: { escapeValue: false },
    //                                             }),
    //                                         }}
    //                                     />
    //                                 );
    //                                 break;
    //                             default:
    //                                 defaultNotificationContent = (
    //                                     <div
    //                                         dangerouslySetInnerHTML={{
    //                                             __html:
    //                                                 vm.props.t('global:error.authentication-resetPassword', { interpolation: { escapeValue: false } }) +
    //                                                 ' <span style="color: #6a8cb0" onclick="openLiveChatPublic()">' +
    //                                                 vm.props.t('global:error.authentication-line-contact') +
    //                                                 '</span>',
    //                                         }}
    //                                     />
    //                                 );

    //                                 if (customTranslationObj && customTranslationObj.errorPendingApproval) {
    //                                     customNotificationContent = (
    //                                         <div
    //                                             dangerouslySetInnerHTML={{
    //                                                 __html: customTranslationObj.errorPendingApproval,
    //                                             }}
    //                                         />
    //                                     );
    //                                 }

    //                                 break;
    //                         }

    //                         if (customNotification) {
    //                             commonUtil.togglePopup(vm, 'notification', customNotificationContent ? customNotificationContent : defaultNotificationContent);
    //                         } else {
    //                             notification.showNotification('error', customNotificationContent ? customNotificationContent : defaultNotificationContent);
    //                         }
    //                     }
    //                 });
    //         }

    //         function customFunctionAfterLoginEvent(callback) {
    //             window.SPL_Content.getLanguageList(vm.props).then((languageListJson) => {
    //                 const { settings } = vm.props.portal;
    //                 const { language, user } = vm.props;
    //                 let countryLanguage = language.countryLanguageKey;

    //                 let currentDomainLanguageKey = countryLanguage && countryLanguage.toLowerCase().replace('_', '-'); // dependency on settngs.enableRedirectAfterLogin
    //                 let remainCurrentDomainLangKey = gu_getNestedValue(settings, 'features.remainCurrentDomainLangKey'); // dependency on settngs.enableRedirectAfterLogin

    //                 if (settings && settings.enableRedirectAfterLogin) {
    //                     let languageModalOrdering = gu_getNestedValue(settings, 'features.languageModalOrdering');
    //                     if (languageModalOrdering) {
    //                         let sort = commonUtil.changeLanguageArrangementSort(languageModalOrdering, languageListJson);
    //                         if (sort) {
    //                             languageListJson = sort;
    //                         }
    //                     }

    //                     let extraLanguage = gu_getNestedValue(settings, 'features.extraLanguage');
    //                     if (extraLanguage) {
    //                         languageListJson.push(extraLanguage);
    //                     }

    //                     let globalCurrency = languageListJson.filter(function (a) {
    //                         let globalCountry = a.languages.filter(function (b) {
    //                             if (user.account && user.account.country) {
    //                                 return b.countryCode.toLowerCase() === user.account.country.toLowerCase();
    //                             } else {
    //                                 return b.currency === user?.account?.actualCurrency || user?.account?.currency;
    //                             }
    //                         });

    //                         return globalCountry.length > 0;
    //                     });

    //                     if (globalCurrency.length <= 0) {
    //                         globalCurrency = languageListJson.filter((a) => a.countryName === 'International');
    //                     }

    //                     let customRegionDefaultLangKey = gu_getNestedValue(settings, 'features.customRegionDefaultLangKey');
    //                     if (customRegionDefaultLangKey) {
    //                         let region = customRegionDefaultLangKey;

    //                         countryLanguage =
    //                             globalCurrency[0] &&
    //                             globalCurrency[0].languages.filter(function (a) {
    //                                 return a.key === region[a.countryName];
    //                             });

    //                         if (!(countryLanguage && countryLanguage.length > 0)) {
    //                             countryLanguage = globalCurrency[0].languages;
    //                         }

    //                         countryLanguage = countryLanguage[0].countryLanguageKey;
    //                     } else {
    //                         if (globalCurrency[0]) {
    //                             countryLanguage = globalCurrency[0].languages[0].countryLanguageKey;
    //                         }
    //                     }

    //                     let countryLanguageKey = countryLanguage;

    //                     core.setLanguageKeyAndCountryLanguage(vm, countryLanguageKey, languageAction);
    //                 }

    //                 countryLanguage = countryLanguage.toLowerCase();
    //                 countryLanguage = countryLanguage.replace('_', '-');

    //                 if (window.isAffiliate) {
    //                     core.portalIsLoading(vm.props, false);
    //                     vm.setState({ isLoading: false }, () => {
    //                         // redirect to last url if url param contains redirect
    //                         let urlParam = window.SPL_Content.parse_query_string();
    //                         if (urlParam.redirect) {
    //                             window.location.href = urlParam.redirect;
    //                         } else {
    //                             window.location.href = '/' + countryLanguage + '/overview';
    //                         }
    //                     });
    //                 } else if (window.isAgent) {
    //                     core.portalIsLoading(vm.props, false);
    //                     vm.setState({ isLoading: false }, () => {
    //                         // redirect to last url if url param contains redirect
    //                         let urlParam = window.SPL_Content.parse_query_string();
    //                         if (urlParam.redirect) {
    //                             window.location.href = '/myaccount/deposit';
    //                         } else {
    //                             window.location.href = '/';
    //                         }
    //                     });
    //                 } else {
    //                     core.portalIsLoading(vm.props, false);

    //                     vm.setState({ isLoading: false }, () => {
    //                         if (history.location.search.includes('App')) {
    //                             history.push('/download' + history.location.search);
    //                             callback && callback();
    //                         } else {
    //                             // redirect to last url if url param contains redirect
    //                             let urlParam = window.SPL_Content.parse_query_string();
    //                             if (urlParam.redirect) {
    //                                 history.push(urlParam.redirect);
    //                                 callback && callback();
    //                             } else {
    //                                 //check user login language key and previous language key to decide isRedirect
    //                                 let checkIsRedirect = new Promise(function (resolve) {
    //                                     core.getCurrentLanguage(false, false, vm, languageAction).then((langPath) => {
    //                                         resolve({
    //                                             isRedirect: true, // diff language
    //                                             currentLang: langPath && langPath.computeLanguage,
    //                                         });
    //                                     });
    //                                 });

    //                                 Promise.all([checkIsRedirect]).then((result) => {
    //                                     let redirectRes = result && result[0];
    //                                     let finalCountryLanguage = remainCurrentDomainLangKey ? currentDomainLanguageKey : redirectRes.currentLang || countryLanguage;

    //                                     if (!screen.isMobile) {
    //                                         if (settings && settings.enableRedirectAfterLogin && !(redirectRes && redirectRes.isRedirect)) {
    //                                             //when enableRedirectAfterLogin is true using isRedirect to decide whether redirect or not in here
    //                                             callback && callback();
    //                                             return;
    //                                         } else if (features && features.customLoginRedirectPage && features.customLoginRedirectPage[screen.viewType]) {
    //                                             if (features.customLoginRedirectPage[screen.viewType] === 'myaccount/mission-diary') {
    //                                                 mu_checkToShowMissionDiary(vm).then((res) => {
    //                                                     window.location.href = res ? features.customLoginRedirectPage[screen.viewType] : '/myaccount/deposit';
    //                                                 });
    //                                             } else {
    //                                                 window.location.href = '/' + finalCountryLanguage + features.customLoginRedirectPage[screen.viewType];
    //                                             }
    //                                         } else {
    //                                             if (settings && settings.features && settings.features.hideLangPathUrl && settings.features.hideLangPathUrl[countryLanguage]) {
    //                                                 window.location.href = '/myaccount/deposit';
    //                                             } else if (!settings?.features?.keptOnCurrentPageAfterLogin) {
    //                                                 window.location.href = '/' + finalCountryLanguage + '/myaccount/deposit';
    //                                             } else if (gu_filterCommonKey(settings, 'features.forceToLoginPageWhilePlyGame')) {
    //                                                 const storedPrevPathHistory = sessionStorage.getItem('prevPathHistory');
    //                                                 sessionStorage.removeItem('prevPathHistory');
    //                                                 window.location.href = storedPrevPathHistory;
    //                                             }
    //                                         }
    //                                     } else {
    //                                         if (settings && settings.landingPageDomains && settings.landingPageDomains.indexOf(window.location.hostname) >= 0) {
    //                                             window.location.href = '/' + countryLanguage;
    //                                         } else if (features && features.customLoginRedirectPage && features.customLoginRedirectPage[screen.viewType]) {
    //                                             if (features.customLoginRedirectPage[screen.viewType] === 'myaccount/mission-diary') {
    //                                                 mu_checkToShowMissionDiary(vm).then((res) => {
    //                                                     window.location.href = res ? features.customLoginRedirectPage[screen.viewType] : '/';
    //                                                 });
    //                                             } else {
    //                                                 window.location.href = '/' + finalCountryLanguage + features.customLoginRedirectPage[screen.viewType];
    //                                             }
    //                                         } else {
    //                                             if (finalCountryLanguage) {
    //                                                 window.location.href = '/' + finalCountryLanguage;
    //                                             } else {
    //                                                 window.location.href = '/';
    //                                             }
    //                                         }
    //                                     }
    //                                 });
    //                             }
    //                         }
    //                     });
    //                 }
    //             });
    //         }
    //     });
    // },

    loadMerchantProvider(vm) {
        window.SPL_Provider.loadProviders().then((data) => {
            vm.props.dispatch(gameAction.updateMerchantProvider(data));

            commonUtil.providerGrouping(vm).then(() => {
                const { sportbook, esport, casino, slots, poker, lottery, fishing, games, cockfight, fourD, fastgames, livegames } = vm.state;
                let tempCategoryList = {
                    S: sportbook || [],
                    ES: esport || [],
                    C: casino || [],
                    SL: slots || [],
                    P: poker || [],
                    L: lottery || [],
                    F: fishing || [],
                    G: games || [],
                    CF: cockfight || [],
                    FD: fourD || [],
                    FG: fastgames || [],
                    LG: livegames || [],
                };

                for (let k = 0; k < Object.keys(tempCategoryList).length; k++) {
                    let categories = Object.keys(tempCategoryList)[k];
                    let providerObj = false;

                    const _providerList = Object.keys(data);
                    providerObj = tempCategoryList?.[categories].some(function (provider) {
                        let validateProvider = _providerList.filter((a) => {
                            return data[a].provider === provider;
                        });

                        return validateProvider.length > 0;
                    });

                    if (!providerObj) {
                        tempCategoryList[categories] = [];
                    }
                }

                vm.setState({ categoryList: tempCategoryList }, () => {
                    window.SPL_Other.sequenceCallback(mu_loadMenuSettings.bind(vm, vm))();
                });
            });
        });
    },
};

export default memberService;
